import { createContext, useContext } from 'react';
import type { InputComboboxOption } from './input_combobox_root.component';

interface InputComboboxContextValue {
	open: boolean;
	loading: boolean;
	multiple: boolean;
	options: InputComboboxOption[];
	optionsToRender: InputComboboxOption[];
	value: string[];
	filterValue: string;
	readOnly: boolean;
	onOptionAdd: (option: InputComboboxOption) => void;
	onOptionRemove: (option: InputComboboxOption) => void;
	onSelectOption: (option: InputComboboxOption) => void;
	onSelectAllOptions: () => void;
	onDeselectAllOptions: () => void;
	onFilter: (query: string) => void;
	onInputChange?: (query: string) => void;
	placeholder?: string;
	contentEmptyText?: string;
}

export const InputComboboxContext = createContext<InputComboboxContextValue | null>(null);

export function useInputComboboxContext() {
	const context = useContext(InputComboboxContext);
	if (!context) {
		throw new Error('useInputComboboxContext must be used within an InputCombobox.Root');
	}
	return context;
}
